import { useNavigate } from 'react-router-dom';
import { useMenuCountStore } from '../../../../app/core/state-management/states/menuCount';
import { convertPersianTime } from '../../../../app/core/utils/utility';
import { KTIcon } from '../../../helpers'

const NotificationListModal = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate()
  const { state } = useMenuCountStore();

  const { allNotifications, menuCountInfo } = state;
  return (
    <div className='card mb-5 col-12'>

      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body p-0'>
        {/* begin::Item */}
        {
          allNotifications?.slice(0,5)?.map(item => (
            <div key={item?.id} className='d-flex align-items-center bg-light-success rounded p-4 mb-3'>
              {/* begin::Icon */}
              <span className=' text-success me-1'>
                <KTIcon iconName='notification' className='text-success fs-1 me-1' />
              </span>
              {/* end::Icon */}
              {/* begin::Title */}
              <div className='flex-grow-1 me-1'>
                <div className='fw-bold text-gray-800 text-hover-primary fs-8'>
                  {item?.title}
                </div>
                <span className='text-muted fw-semibold d-block fs-9'>{item?.body}</span>
                <span className='fw-bold py-1 fs-9'>{convertPersianTime(item?.createdAt || '')}</span>
              </div>
              {/* end::Title */}
              {/* begin::Lable */}
              {/* end::Lable */}
            </div>
          ))
        }
        {/* end::Item */}
        <button className='btn btn-success w-100 btn-sm' onClick={() => {
          navigate('/notifications')
          onClose()
        }}>
          <span>مشاهده همه اعلانات ({menuCountInfo?.allNotification})</span>
          <KTIcon iconName='arrow-left' className='fs-1 me-1' />
        </button>
      </div>
      {/* end::Body */}
    </div>
  )
}

export { NotificationListModal }
